// extracted by mini-css-extract-plugin
export var productImage = "_p3-1";
export var viewLink = "_p3-2";
export var wishlistItem = "_p3-0";